import React from "react";

type WhyChooseUsNumericCardProps = {
  index: number;
  text: string;
};

const WhyChooseUsNumericCard: React.FC<WhyChooseUsNumericCardProps> = ({
  index,
  text,
}) => {
  return (
    <div
      className="xb-numeric-card"
      style={{
        padding: "35px 30px",
        borderRadius: "16px",
        background: "rgba(255,255,255,0.06)",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(255,255,255,0.08)",
        transition: "0.3s",
      }}
    >
      {/* NUMBER CIRCLE */}
      <div
        style={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          margin: "0 auto 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 24,
          fontWeight: 700,
          color: "#fff",
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))",
          border: "1px solid rgba(255,255,255,0.25)",
        }}
      >
        {index + 1}
      </div>

      {/* TEXT */}
      <h4 style={{ color: "#fff", fontWeight: 600 }}>{text}</h4>
    </div>
  );
};

export default WhyChooseUsNumericCard;
